'use client';

import { useRef } from 'react';
import clsx from 'clsx';
import Tabs from '@/components/Tabs';
import useAccordion from '@/hooks/useAccordion';
import EditButton from '@/components/Button/EditButton';
import { BuyWithConfidenceProps, START_INDEX } from './types';
import styles from './BuyWithConfidence.module.css';

const AccordionItem = ({ itemId, title, description }: { itemId: number; title: string; description: string }) => {
  const accordionContent = useRef<HTMLDivElement>(null);
  const { height, handleAccordionOpen, isShortListOpened } = useAccordion({
    shortListRef: accordionContent,
    isOpened: false,
    duration: 300,
  });

  return (
    <div className={styles.buyWithConfidenceAccordion}>
      <div
        data-testid={'buy-with-confidence-accordion'}
        className={clsx(styles.buyWithConfidenceAccordionHeader, { [styles.active]: isShortListOpened.current })}
        onClick={handleAccordionOpen}
      >
        <div>
          {title}
          <EditButton
            id={`accordion-edit-${START_INDEX + itemId}`}
            recordId={`${START_INDEX + itemId}`}
            slug="promoAlertMessageEdit"
            className={styles.editIcon}
          />
        </div>
        <span className={clsx({ [styles.down]: isShortListOpened.current }, styles.accordionIcon)}></span>
      </div>
      <div ref={accordionContent} style={{ height: height }} className={styles.buyWithConfidenceAccordionContent}>
        <div dangerouslySetInnerHTML={{ __html: description }} />
      </div>
    </div>
  );
};

const BuyWithConfidence = ({ data = [], classes }: BuyWithConfidenceProps) => {
  return data.length > 0 ? (
    <section className={styles.buyWithConfidenceWrapper}>
      <div className={clsx(styles.container, classes)}>
        <div className={styles.buyWithConfidenceTitle}>Buy With Confidence</div>
        {data.map((tab, idx: number) => (
          <AccordionItem key={`accordion-${tab.name}`} itemId={idx} title={tab.name} description={tab.description} />
        ))}
        <div className={styles.buyWithConfidenceTabs}>
          <Tabs tabsData={data} tabsDesctiptionClassName={styles.tabDescription} />
        </div>
      </div>
    </section>
  ) : null;
};

export default BuyWithConfidence;
